import { useTranslation } from "react-i18next";

import { FormikProps } from "formik";

import { useConfirmationDialogContext } from "../../../../../confirmation-dialog/ConfirmationDialogContext";
import { nameof } from "../../../../../utils/nameof";
import { PropertyRightsFormValues } from "../OtherPropertyRightsView.types";
import { withoutRight } from "../OtherPropertyRightsView.utils";

const TAB = "clients.client.debtSettlement.assetInventory.propertyRightsTab";
const RIGHTS_FIELD = nameof<PropertyRightsFormValues>("propertyRights");

/** Asks for confirmation, then removes the block from the form; saving soft-deletes a stored entry. */
export function useRemoveRight(formik: FormikProps<PropertyRightsFormValues>) {
  const { t } = useTranslation();
  const { showConfirmationDialog } = useConfirmationDialogContext();

  return (index: number) =>
    showConfirmationDialog({
      dialogTitleText: t(`${TAB}.removeConfirmTitle`),
      dialogText: t(`${TAB}.removeConfirm`),
      agreeText: t("common.yes"),
      discardText: t("common.no"),
      onClose: (confirmed) => {
        if (confirmed) {
          void formik.setFieldValue(RIGHTS_FIELD, withoutRight(formik.values.propertyRights, index));
        }
      },
    });
}
